<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-content>
    <div class="row">
      <div class="col-sm-12">
        <h3>You're almost there!</h3>
      </div>
    </div>

    <div class="row mt-4 mb-4" *ngIf="ndiResultsEnabled">
      <div class="col-12">
        <div class="pt-3 pb-1 ps-3 pe-3 {{(!pndiPass && isNasApplicationType && ndiPass) ? 'warning-block' : ndiStatusClassName}}">
          <p>
            <ng-container *ngIf="ndiPass; else ndiFail">
              Servicing result (NDI score) is {{ndiScore}}. PASS Based on the information entered, the proposed loan meets our
              servicing requirements. Complete the information below and upload the supporting documents to proceed to submission.
            </ng-container>

            <ng-template #ndiFail>
              Servicing Result (NDI Score) is {{ndiScore}}. FAIL. Based on the information entered, the proposed loan doesn’t
              meet our servicing requirements, please review the application details. If you wish for the loan to be submitted as
              is, notes must be entered below supporting why the application should proceed.
            </ng-template>
          </p>

          <p>
            Note: The servicing result displayed does not cater for linked applications and applications for existing Firstmac customers.
            Please check servicing for these scenarios in the Broker Tools Debt Servicing Calculator.
          </p>

          <ng-container *ngIf="!runningCalculations">
            <div class="row mt-4 mb-4" *ngIf="!pndiPass && isNasApplicationType && ndiPass">
              <div class="col-12"><strong>
                <p>The application does not meet our servicing requirements as a Non Applicant Spouse application and cannot be submitted as presented.</p>
                <p>
                  However, this can be considered as a joint loan application if the applicant and non applicant spouse wish to proceed.
                  If you hold the appropriate privacy consents, you can return to the Application Commencement page and update the Borrower Type to a Joint Application.
                </p>
              </strong></div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>

    <ng-container *ngIf="runningCalculations">
      <div class="row mt-4 mb-4 d-flex align-items-center">
        <div class="col-2">
          <strong>Calculating...</strong>
        </div>
        <div class="col-10">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
    </ng-container>

    <div *ngIf="!isInternalUser || !isHomeLoan">
      <div class="row">
        <div class="col-12">
          <h4>I confirm</h4>
          <ul>
            <li>I confirm that the customer/s have signed and accepted our approved privacy declaration form in relation
              to the submission of this loan application.
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <mat-checkbox formControlName="generalTerms" class="d-inline-flex" (change)="checkGeneralTerms($event)">I confirm all of the above</mat-checkbox>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'generalTerms'"
            ></app-validation-partial>
          </mat-error>
        </div>
      </div>
    </div>

    <div *ngIf="isInternalUser && isHomeLoan">
      <div class="row">
        <div class="col-12">
          <h4>Privacy Consent</h4>
          <ul class="list-unstyled">
            <li>Please confirm which of the customer/s have signed and accepted our approved privacy declaration form in relation
              to the submission of this loan application.
            </li>
            <li *ngIf="!formGroup.get('generalTerms').value" class="text-danger">
              Privacy consent must be accepted for at least one of the borrowers/guarantors
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <ng-container *ngFor="let person of personList?.controls">
              <li [formGroup]="person" *ngIf="person?.value?.borrowerGuarantor === 'borrower' || person?.value?.borrowerGuarantor === 'guarantor'">
                <mat-checkbox formControlName="privacyConsent" class="d-inline-flex" (change)="checkSubmissionValidation()">
                  Privacy consent confirmed for {{person?.value?.firstName}} {{person?.value?.lastName}}
                </mat-checkbox>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
